export default "__VITE_ASSET__BhUV2ZUR__"